import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cancelOrder, editOrder } from '../../services/PortfolioOpenOrder';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: false,
};
export const cancelOpenOrderAction = createAsyncThunk('CANCEL_OPEN_ORDER', cancelOrder);
export const editOrderAction = createAsyncThunk('EDIT_ORDER_ACTION', editOrder);

export const portfolioOpenOrderSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [cancelOpenOrderAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [cancelOpenOrderAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
      };
    },
    [cancelOpenOrderAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },

    //edit your order
    [editOrderAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [editOrderAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
      };
    },
    [editOrderAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
      };
    },
  },
});
const { reducer } = portfolioOpenOrderSlice;
export default reducer;
